/* ProvAI — dönüşüm izleme (sepete ekleme / sepetten çıkarma).
 * ProvAI önizlemesi YAPILMIŞ ürünler sepete eklenince veya sepetten çıkınca,
 * worker'a mode:'event' ile cart_add / cart_remove olayı gönderir.
 * Tema-bağımsız: window.fetch sarılır, /cart/add ve /cart/change|update yanıtları dinlenir.
 *
 * ÖNEMLİ (2026-09-25): Bu dosya uzun süre hiçbir şablondan YÜKLENMİYORDU; cart_add
 * olayı 16.06.2026'dan beri hiç düşmedi, Görsel Hunisi'nin sepet adımı hep 0 göründü.
 * Artık snippets/scripts.liquid global olarak yüklüyor — oradan kaldırılırsa adım
 * yeniden sessizce sıfırlanır.
 */
(function () {
  var PROXY_URL = 'https://fal-proxy-v2.cercilerkumas.workers.dev';

  function ids() {
    var vid = null, sid = null;
    try { vid = localStorage.getItem('ai_vid'); } catch (e) {}
    try { sid = sessionStorage.getItem('ai_sid'); } catch (e) {}
    return { visitor_id: vid, session_id: sid };
  }

  // Kalıcı üretim hafızası: panel görsel üretince localStorage'a
  // { handle: { s: yüzey, first: tarih } } yazar. Siparişe basılan _provai_gen
  // atfı da buradan doğuyor — sepet adımı da aynı kaynağı kullanmalı.
  function genMap() {
    try { return JSON.parse(localStorage.getItem('provai_gen') || '{}') || {}; } catch (e) { return {}; }
  }

  // Önizlemesi yapılmış ürünler. İki kaynağın BİRLEŞİMİ:
  //   sessionStorage 'ai_previewed' → bu oturumda önizlenenler
  //   localStorage  'provai_gen'    → geçmiş oturumlarda önizlenenler
  // Yalnız sessionStorage'a bakılırsa müşteri görseli bugün üretip yarın satın
  // aldığında sepet olayı düşmez, ama satış _provai_gen ile yine sayılır; huni
  // "satış var, sepete ekleme yok" gibi imkânsız görünür.
  function previewedSet() {
    var out = [];
    try {
      var s = JSON.parse(sessionStorage.getItem('ai_previewed') || '[]') || [];
      for (var i = 0; i < s.length; i++) if (out.indexOf(s[i]) === -1) out.push(s[i]);
    } catch (e) {}
    try {
      var keys = Object.keys(genMap());
      for (var j = 0; j < keys.length; j++) if (out.indexOf(keys[j]) === -1) out.push(keys[j]);
    } catch (e) {}
    return out;
  }

  function getSnap() {
    try { return JSON.parse(sessionStorage.getItem('ai_cart_snap') || '{}') || {}; } catch (e) { return {}; }
  }
  function saveSnap(s) { try { sessionStorage.setItem('ai_cart_snap', JSON.stringify(s)); } catch (e) {} }

  // Bu ürünü hangi ProvAI yüzeyi önizledi? Önce bu oturumun haritası, sonra kalıcı
  // üretim kaydı. Kayıt yoksa 'studio': ayrışmadan önceki oturumların tamamı ürün
  // sayfası akışıydı.
  function surfaceOf(handle) {
    try {
      var m = JSON.parse(sessionStorage.getItem('ai_preview_surface') || '{}') || {};
      if (m[handle]) return m[handle] === 'designer' ? 'designer' : 'studio';
    } catch (e) {}
    try {
      var rec = genMap()[handle];
      if (rec && rec.s) return rec.s === 'designer' ? 'designer' : 'studio';
    } catch (e) {}
    return 'studio';
  }

  function post(eventType, handle, variant) {
    var i = ids();
    if (!i.visitor_id && !i.session_id) return; // ProvAI hiç kullanılmamış → izleme yok
    try {
      fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          mode: 'event',
          event_type: eventType,
          visitor_id: i.visitor_id,
          session_id: i.session_id,
          product: handle || null,
          variant: variant != null ? String(variant) : null,
          source: 'cart',
          surface: surfaceOf(handle),
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  // Önizlenen ürünlerin sepetteki adetlerinden anlık görüntü çıkar.
  function qtyByHandle(cart) {
    var qty = {};
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      if (it && it.handle) qty[it.handle] = (qty[it.handle] || 0) + (it.quantity || 0);
    });
    return qty;
  }

  // Kumaş Bulucu "İncele → ürün sayfası" yolu (path B): kumas-bulucu.liquid tıklanan
  // ürünü localStorage 'kbul_intent'e yazar; ürün sayfasında sepete eklenince burada
  // worker'a /quiz/feedback (kind:'cart', via:'product') gönderilir.
  function kbulIntent() {
    try { return JSON.parse(localStorage.getItem('kbul_intent') || '{}') || {}; } catch (e) { return {}; }
  }
  function postQuizCart(handle, rec) {
    // Kimlik: niyet kaydında saklanan müşteri id/e-postası (kumas-bulucu.liquid yazar),
    // yoksa sayfada tanımlıysa global. Günlük raporda kullanıcı listesi bundan doğar.
    var cid = (rec && rec.cid) || null, cem = (rec && rec.cem) || null, vid = null;
    if (!cid) { try { cid = (window.__kbulCustomer || null); } catch (e) {} }
    try { vid = localStorage.getItem('ai_vid'); } catch (e) {}
    try {
      fetch(PROXY_URL + '/quiz/feedback', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ kind: 'cart', product: handle,
          facets: Object.assign({ via: 'product' }, (rec && rec.facets) || {}),
          customer_id: cid, customer_email: cem, visitor_id: vid }),
      }).catch(function () {});
    } catch (e) {}
  }

  function handleAddResponse(data) {
    var items = data && data.items ? data.items : (data && (data.id || data.handle) ? [data] : []);
    var prev = previewedSet();
    var intent = kbulIntent();
    var intentChanged = false;
    items.forEach(function (it) {
      if (!it || !it.handle) return;
      if (prev.indexOf(it.handle) !== -1) post('cart_add', it.handle, it.variant_id || it.id);
      if (intent[it.handle]) {
        postQuizCart(it.handle, intent[it.handle]);   // path B: Kumaş Bulucu ürün-sayfası satışı
        delete intent[it.handle]; intentChanged = true;
      }
    });
    if (intentChanged) { try { localStorage.setItem('kbul_intent', JSON.stringify(intent)); } catch (e) {} }
  }

  function handleCartState(cart) {
    if (!cart || !cart.items) return;
    var prev = previewedSet();
    var qty = qtyByHandle(cart);
    var old = getSnap();
    prev.forEach(function (h) {
      var before = old[h] || 0, now = qty[h] || 0;
      if (before > 0 && now === 0) post('cart_remove', h, null);
    });
    var ns = {};
    prev.forEach(function (h) { ns[h] = qty[h] || 0; });
    saveSnap(ns);
  }

  // Açılışta mevcut sepetten snapshot al (önceki oturumda eklenen ürünlerin çıkarılmasını da yakalayabilmek için).
  var origFetch = window.fetch;
  if (!origFetch) return;
  try {
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prev = previewedSet(), qty = qtyByHandle(cart), ns = {};
        prev.forEach(function (h) { ns[h] = qty[h] || 0; });
        saveSnap(ns);
      })
      .catch(function () {});
  } catch (e) {}

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try {
      if (/\/cart\/(add|change|update)(\.js)?/i.test(url)) {
        p.then(function (res) {
          if (!res || !res.clone) return;
          res.clone().json().then(function (data) {
            if (/\/cart\/add/i.test(url)) handleAddResponse(data);
            else handleCartState(data);
          }).catch(function () {});
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
})();
